import React from 'react';
import { roleConstants } from '../../constants/roleConstants';
import { PrivateRoute } from './PrivateRoute';

export const WeightControlRoute = ({ ...props }) => {
  return <PrivateRoute {...props} role={roleConstants.ROLE_WEIGHT_CONTROL} />;
};
